import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  justify-content: space-between;

  label {
    cursor: pointer;
    display: flex;
    flex-direction: column;
  }

  input {
    cursor: pointer;
    height: 25px;
    width: 25px;
    color: ${props => props.theme.colors.color122d52};

    &:focus-within {
      border: 1px solid ${props => props.theme.colors.color378ff7};
      border-radius: 4px;
    }
  }

  span {
    font-family: 'Inter';
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: center;
  }
`

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const LabelSpan = styled.span`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: ${props => props.theme.colors.color545e6c};
`
